import { ArticleInstancePlacement } from 'api/models';
import { PreviewLoader } from 'app/modules/wallforming/components/scenes/objects/placement-preview/PreviewLoader';

interface PreviewInstanceProps {
    articleId: string;
    articleNumber: string;
    instance: ArticleInstancePlacement;
    useDefaultMaterial: boolean;
    onLoaded?: () => void;
}

export const PreviewInstance = ({ articleId, articleNumber, instance, useDefaultMaterial, onLoaded }: PreviewInstanceProps) => (
    <>
        {instance.parts.map((part, index) => (
            <PreviewLoader
                key={`${instance.id}-${part.name}-${index}`}
                articleId={articleId}
                articleNumber={articleNumber}
                part={part}
                useDefaultMaterial={useDefaultMaterial}
                onLoaded={onLoaded}
            />
        ))}
    </>
);
